// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiStepper-horizontal{
    padding: 5px !important;
    width: 99%;
   
    
}

/* .MuiPaper-root{
    background-color: #1C1E24 !important;
} */

.makeStyles-root-1{
    width: 95% !important;
    height: 560px !important;
    
}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
    color: #666666 !important;
    background: #919191 !important;
    border: 1px solid #999999 !important;
  
  }

.MuiStepIcon-root.MuiStepIcon-active{
    color: linear-gradient(90deg, rgba(73,150,238) 0%, rgba(37,75,119) 100%) !important;
}

.notif{
    color: #E1E1E1;
}

.makeStyles-root-69{
    padding: 5px !important;
}
.newComplexContainer{
    height: 650px;
    width: 100% !important;
    background-color: #1C1E24;
}
.makeStyles-root-135{
    width: auto !important;
}
.Contents{
    background-color: #282B30;
    width: 100%;
    height: 50%;
    padding: 5px;
}
.MuiInputLabel-animated{
transition: none !important;
}
.partOne .MuiFormControl-root{
    width: 100% !important;
    border: none !important;
    border-radius: 0 !important;
    margin: 7px;
    
}
.partOne .MuiInputBase-root{
    width: 90%;
    background-color: #1C1E24;
    border-bottom: none !important;
    height: 35px;
    color: #fff;
    padding: 10px;
}
#outlined-multiline-flexible{
    height: 100% !important;
}
.label{
    text-align: left;
    color: #E1E1E1;
    padding-left: 10px;
}
.multiLine .MuiInputBase-root{
    width: 97% !important;
    height: 180px;
}

.partOne .MuiInput-underline:after{
    transition: none !important;
    border-bottom: none;
}
#info3{
    width: 100%;
}

.partOne .MuiInput-underline:before{
    transition: none !important;
    border-bottom: none;
}
.partOne .MuiInput-underline:hover{
    border-bottom: none;
}


.partOne .MuiOutlinedInput-input{
    border: none !important;
    padding: 0;
    border-radius: 0 !important;
    margin: 7px;;
}
.partOne .MuiOutlinedInput-root{
    background-color: #1C1E24;
    border: none !important;
    border-radius: 0 !important;
    padding: 5px;
}
.partOne .MuiOutlinedInput-notchedOutline{
    border-color: transparent;
}

.partOne .MuiInputBase-input:focus{
    color: #fff !important;
    border-radius: 0 !important;
}
.partOne .MuiInputBase-input{
    border-radius: 0 !important;
    color: #fff !important;
}
.newcTiltle{
    text-align: left;
    color: #E1E1E1;
    padding-top: 15px;
    padding-left: 20px;
}
.newcTiltle h2{
    margin: 0;
}

.partOne .MuiOutlinedInput-notchedOutline{
    border-color: transparent !important;
}

.partOne .MuiInputLabel-outlined{
    color: #fff;
}
.Contents .MuiButton-containedPrimary{
    background: linear-gradient(90deg, rgba(73,150,238) 0%, rgba(37,75,119) 100%) !important;
    border-radius: 0 !important;
}
.Contents .MuiButton-containedPrimary:hover{
    background: linear-gradient(90deg,rgba(37,75,119) 0%, rgba(73,150,238) 100%) !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ComplexWizard/ComplexWizard.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,UAAU;;;AAGd;;AAEA;;GAEG;;AAEH;IACI,qBAAqB;IACrB,wBAAwB;;AAE5B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;;EAEtC;;AAEF;IACI,mFAAmF;AACvF;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,YAAY;AAChB;AACA;AACA,2BAA2B;AAC3B;AACA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,WAAW;;AAEf;AACA;IACI,UAAU;IACV,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,aAAa;AACjB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;;;AAGA;IACI,uBAAuB;IACvB,UAAU;IACV,2BAA2B;IAC3B,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,SAAS;AACb;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;AACf;AACA;IACI,wFAAwF;IACxF,2BAA2B;AAC/B;AACA;IACI,uFAAuF;AAC3F","sourcesContent":[".MuiStepper-horizontal{\n    padding: 5px !important;\n    width: 99%;\n   \n    \n}\n\n/* .MuiPaper-root{\n    background-color: #1C1E24 !important;\n} */\n\n.makeStyles-root-1{\n    width: 95% !important;\n    height: 560px !important;\n    \n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n    color: #666666 !important;\n    background: #919191 !important;\n    border: 1px solid #999999 !important;\n  \n  }\n\n.MuiStepIcon-root.MuiStepIcon-active{\n    color: linear-gradient(90deg, rgba(73,150,238) 0%, rgba(37,75,119) 100%) !important;\n}\n\n.notif{\n    color: #E1E1E1;\n}\n\n.makeStyles-root-69{\n    padding: 5px !important;\n}\n.newComplexContainer{\n    height: 650px;\n    width: 100% !important;\n    background-color: #1C1E24;\n}\n.makeStyles-root-135{\n    width: auto !important;\n}\n.Contents{\n    background-color: #282B30;\n    width: 100%;\n    height: 50%;\n    padding: 5px;\n}\n.MuiInputLabel-animated{\ntransition: none !important;\n}\n.partOne .MuiFormControl-root{\n    width: 100% !important;\n    border: none !important;\n    border-radius: 0 !important;\n    margin: 7px;\n    \n}\n.partOne .MuiInputBase-root{\n    width: 90%;\n    background-color: #1C1E24;\n    border-bottom: none !important;\n    height: 35px;\n    color: #fff;\n    padding: 10px;\n}\n#outlined-multiline-flexible{\n    height: 100% !important;\n}\n.label{\n    text-align: left;\n    color: #E1E1E1;\n    padding-left: 10px;\n}\n.multiLine .MuiInputBase-root{\n    width: 97% !important;\n    height: 180px;\n}\n\n.partOne .MuiInput-underline:after{\n    transition: none !important;\n    border-bottom: none;\n}\n#info3{\n    width: 100%;\n}\n\n.partOne .MuiInput-underline:before{\n    transition: none !important;\n    border-bottom: none;\n}\n.partOne .MuiInput-underline:hover{\n    border-bottom: none;\n}\n\n\n.partOne .MuiOutlinedInput-input{\n    border: none !important;\n    padding: 0;\n    border-radius: 0 !important;\n    margin: 7px;;\n}\n.partOne .MuiOutlinedInput-root{\n    background-color: #1C1E24;\n    border: none !important;\n    border-radius: 0 !important;\n    padding: 5px;\n}\n.partOne .MuiOutlinedInput-notchedOutline{\n    border-color: transparent;\n}\n\n.partOne .MuiInputBase-input:focus{\n    color: #fff !important;\n    border-radius: 0 !important;\n}\n.partOne .MuiInputBase-input{\n    border-radius: 0 !important;\n    color: #fff !important;\n}\n.newcTiltle{\n    text-align: left;\n    color: #E1E1E1;\n    padding-top: 15px;\n    padding-left: 20px;\n}\n.newcTiltle h2{\n    margin: 0;\n}\n\n.partOne .MuiOutlinedInput-notchedOutline{\n    border-color: transparent !important;\n}\n\n.partOne .MuiInputLabel-outlined{\n    color: #fff;\n}\n.Contents .MuiButton-containedPrimary{\n    background: linear-gradient(90deg, rgba(73,150,238) 0%, rgba(37,75,119) 100%) !important;\n    border-radius: 0 !important;\n}\n.Contents .MuiButton-containedPrimary:hover{\n    background: linear-gradient(90deg,rgba(37,75,119) 0%, rgba(73,150,238) 100%) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
